import React from "react";

import {
  Container,
} from "./Components";
import Card from "../Card/Card";

const CardsContainer = ({ cards, images }) => {
  return (
    <Container>
      {cards.map((card, index) => {
        return (
          <Card
            key={card.id}
            title={card.title}
            image={images[index]}
            content={card.content}
          />
        );
      })}
    </Container>
  );
};

export default CardsContainer;
